import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';  // <-- ये जरूरी है
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';

import StickySettings from './cmp/Layout/DashboardContent/StoreConnections/StickySettings/StickySettings';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <StickySettings /> */}
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
